<!-- MAIA Step 3 of 4 — Portfolio ready (final enrich screen). -->
<div class="maia-ready-step" data-testid="maia-ready-step">


    <header class="step-header">
        <div class="step-heading">
            <h1>Enrichment Complete</h1>
            <p>
                Your enriched file is ready for download. Next use Overview Reporting for quick risk
                summaries and loss analytics, or import your portfolio directly to MAPTYCS for full platform access.
                Please download the enriched locations file to proceed to the next step.
            </p>
            <!-- <div class="step-meta">Step 3 of 4 · Enrich</div>
            <div class="step-dots">
                <span class="dot"></span><span class="dot"></span>
                <span class="dot active"></span><span class="dot"></span>
            </div> -->
        </div>
    </header>

    <section class="ready-card">
        <div class="ready-line">
            <span class="ready-check" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
            </span>
            <span class="ready-text">
                <strong>{{ fileName || 'Your portfolio' }}</strong>
            </span>
        </div>
        <button type="button" class="btn btn-download" (click)="downloadRequested.emit()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 3v12"></path><polyline points="7 10 12 15 17 10"></polyline>
                <path d="M5 21h14"></path>
            </svg>
            Download Enriched File
        </button>
    </section>

    <footer class="step-footer">
        <button type="button" class="btn btn-secondary" [class.is-disabled]="!locationsDownloaded"
                [matTooltip]="gateHint('Overview Report')" matTooltipPosition="above"
                (click)="onOverviewReport()">Overview Report</button>
        <button type="button" class="btn btn-primary" [class.is-disabled]="!locationsDownloaded"
                [matTooltip]="gateHint('Import to Maptycs')" matTooltipPosition="above"
                (click)="onImport()">Import to Maptycs</button>
    </footer>
</div>
